<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Part-Title-1">Yen Pox</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Meyer_LotusCrew_4P_MD-2.vue?e9e2ade8